/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import RemitAccountDetailsPopup from "../../../../components/Accounts/RemitAccount/RemitAccountDetailsPopup/index.jsx";
import Loader from "../../../../components/Loader/Index";
import CommonAccountApprovalCard from "../../../../components/_utils/CommonAccountApprovalCard/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import {
  getAssociatedConsolidatedStatements,
  getAssociatedItemisedStatements,
  remitterAccountApprove,
  remitterAccountReject,
  remitterAccountViewAll,
  remitterAddNewLabel,
  remitterRemoveNewLabel,
  removeUnmatchConsolidatedStatement,
  removeUnmatchItemisedStatement,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import OwnerAccountConsolidatedBankStatement from "../../OwnerAccount/OwnerAccountConsolidatedBankStatement/index.jsx";
import OwnerAccountItemisedReportComp from "../../../../components/Accounts/OwnerAccount/OwnerAccountConsolidatedLiveStatementComp/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import UseHandleScroll from "../../../../hooks/useHandleScroll";
import RemitAccountViewAllPopup from "../../../../components/Accounts/RemitAccount/RemitAccountViewAllPopup/index.jsx";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";

const RemitterAccountApproval = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dateRef = useRef(null);
  const filterRef = useRef(null);
  const sidebarRef = useRef(null);
  const dropdownRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const sidebarButtonRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[0],
    });
  const {
    remitterAccountDetailsData,
    remitterAccountDetailsLoading,
    remitterAccountRejectLoading,
    remitterAccountViewAllData,
    remitterAccountViewAllLoading,
  } = useSelector((state) => state.remitterAccount);

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );
    return timestamp;
  };

  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const hasLiveStatementPermission = services?.some(
    (service) => service === "VItemisedStatement" || service === "Admin",
  );

  const hasUnmatchPermission = services?.some(
    (service) => service === "RMapping" || service === "Admin",
  );

  const [accountbalancestate, setaccountbalancestate] = useState(
    searchParam.get("sort") || "",
  );
  const [labels, setLabels] = useState([]);
  const [active, setActive] = useState("");
  const [loading, setLoading] = useState({});
  const [labelId, setLableId] = useState([]);
  const [isService, setIsService] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [accountType, setAccountType] = useState(
    searchParam.get("accountType") || "",
  );
  const [mainData, setMainData] = useState([]);
  const [deniedId, SetDeniedId] = useState(null);
  const [matchStatements, setMatchStatements] = useState({
    bankStatement: [],
    bankStatementCount: 0,
    liveStatement: [],
    liveStatementCount: 0,
  });
  const [rejectBankStatement, setrejectBankStatement] = useState(false);
  const [rejectLiveStatement, setRejectLiveStatement] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [panNumber, setPanNumber] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [btnClicked, setBtnClicked] = useState({});
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [isFocused, setIsFocused] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [declineType, setDeclineType] = useState("");
  const [allAccounts, setAllAccounts] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [remaccountID, setremaccountID] = useState("");
  const [ErrorMessage, SetErrorMessage] = useState({});
  const [approvedCount, setApprovedCount] = useState(0);
  const [labelAccounts, setLabelAccounts] = useState([]);
  const [accountNumber, setAccountNumber] = useState("");
  const [declineReason, setDeclineReason] = useState("");
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [similarAccountPopup, setSimilarAccountPopup] = useState(false);
  const [similarAccountInfo, setSimilarAccountInfo] = useState({
    id: "",
    name: "",
  });
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",") || [],
  );
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [remMatchaccountID, setRemMatchaccountID] = useState("");
  const [remUnamtchaccountID, setRemUnmatchaccountID] = useState("");
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [remiiterLoadingData, setRemitterLoadingData] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [allRemitterAccountLoading, setAllRemitterAccountLoading] =
    useState(false);

  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");
  const { handleScroll } = UseHandleScroll(setDirection, lastScrollTop);

  const [isAlertPopup, setAlertPopUp] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const { remitterAccountApproveData } = useSelector((state) => {
    return state.remitterAccount;
  });

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };
  const updateAllAccounts = (updatedAccounts) => {
    setAllAccounts(updatedAccounts);
  };

  let approvedpadCount;
  let deniedCount = 0;

  const updateIsFilterApplied = () => {
    setIsFilterApplied(!!(startDateFilter && endDateFilter));
  };

  useEffect(() => {
    updateIsFilterApplied();
  }, [startDateFilter, endDateFilter]);

  const hasAnyFilter =
    // Boolean(currentCategory?.length) ||
    Boolean(LabelSearchText?.length) ||
    Boolean(accountNumber?.length) ||
    Boolean(panNumber?.length) ||
    Boolean(searchUserText?.length) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter))) ||
    accountType !== "" ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !allRemitterAccountLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allRemitterAccountLoading &&
    accumulatedData?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const handleInputChange = (event) => {
    let value = event?.target?.value;
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    value = value.slice(0, 150);
    setDeclineReason(value);
  };

  const unamtchAllTxn = async (id) => {
    try {
      toast.dismiss();
      UniversalRefreshToast("Unmatching transactions and rejecting account.");

      const pageSize = PaginationConfiguration.paginationSmall;

      if (matchStatements?.bankStatement) {
        const bankCount = matchStatements?.bankStatementCount ?? 0;

        let remitterIds = [];

        if (bankCount > GlobalConfiguration.lengthCheckZero) {
          const totalBankPages = Math.ceil(bankCount / pageSize);

          for (
            let page = GlobalConfiguration.lengthCheckOne;
            page <= totalBankPages;
            page++
          ) {
            const consolidatedResponse = await dispatch(
              getAssociatedConsolidatedStatements({
                page_no: page,
                page_size: pageSize,
                remitter_account_id: id,
              }),
            ).unwrap();

            const consolidatedStatements =
              consolidatedResponse?.statement || [];

            const pageIds = consolidatedStatements
              .map((data) => data?.account_statement_entry_id)
              .filter(Boolean);

            remitterIds.push(...pageIds);
          }
        }

        if (remitterIds.length > GlobalConfiguration.lengthCheckZero) {
          toast.dismiss();
          await dispatch(
            removeUnmatchConsolidatedStatement({
              remitter_accounts_ids: [id],
              mapping_ids: remitterIds,
            }),
          ).unwrap();

          setAllAccounts((prevAccounts) =>
            prevAccounts.map((account) =>
              account.id === id
                ? {
                    ...account,
                    mapped_consolidated_statement_entries_count: 0,
                  }
                : account,
            ),
          );
        }
      }

      if (matchStatements?.liveStatement) {
        const liveCount = matchStatements?.liveStatementCount ?? 0;

        let itemisedIds = [];

        if (liveCount > GlobalConfiguration.lengthCheckZero) {
          const totalLivePages = Math.ceil(liveCount / pageSize);

          for (
            let page = GlobalConfiguration.lengthCheckOne;
            page <= totalLivePages;
            page++
          ) {
            const itemisedResponse = await dispatch(
              getAssociatedItemisedStatements({
                page_no: page,
                page_size: pageSize,
                remitter_account_id: id,
              }),
            ).unwrap();

            const itemisedStatements =
              itemisedResponse?.ecollection_callbacks || [];

            const pageIds = itemisedStatements
              .map((data) => data?.ecollection_callback_id)
              .filter(Boolean);

            itemisedIds.push(...pageIds);
          }
        }

        if (itemisedIds.length > GlobalConfiguration.lengthCheckZero) {
          toast.dismiss();
          await dispatch(
            removeUnmatchItemisedStatement({
              remitter_accounts_ids: [id],
              mapping_ids: itemisedIds,
            }),
          ).unwrap();

          setAllAccounts((prevAccounts) =>
            prevAccounts.map((account) =>
              account.id === id
                ? {
                    ...account,
                    mapped_itemised_consolidated_statement_entries_count: 0,
                  }
                : account,
            ),
          );
        }
      }

      CommonToast({
        text: "Transactions unmatched and account rejected successfully.",
        variant: "var(--success)",
        icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        buttonNeeded: false,
      });

      handleDeclined(id, declineReason);
    } catch (error) {
      toast.dismiss();

      CommonToast({
        text:
          error?.message ||
          error?.errors?.user_unauthorized?.[0] ||
          "Something went wrong while unmatching transactions.",
        variant: "var(--error)",
        icon: ICONS.ERROR,
        buttonNeeded: false,
      });
    } finally {
      setShowPopup(false);
    }
  };

  const fetchRemitterAccountData = async () => {
    let data = [];
    setRemitterLoadingData(true);
    switch (active) {
      case "Labels":
        data = labels
          ?.filter((itm) => itm.includes(searchUserTextDebounce))
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setRemitterLoadingData(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchRemitterAccountData();
    }
  }, [active]);

  const fetchData = async () => {
    try {
      setAllRemitterAccountLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        approval_status: "pending",
        isDashboardCall: false,
        // sort_by: accountbalancestate === "Oldest first" ? "oldest" : "latest",
      };

      if (searchUserText !== "") {
        queryParams.search_string = searchUserText;
      }

      if (accountType !== "") {
        queryParams.account_type = accountType;
      }

      if (LabelSearchText?.length !== 0) {
        queryParams.labels = LabelSearchText;
      }

      if (
        startDateFilter !== "" &&
        endDateFilter !== "" &&
        startDateFilter !== GlobalConfiguration?.lengthCheckZero &&
        endDateFilter !== GlobalConfiguration?.lengthCheckZero &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.start_date =
          startDateFilter + GlobalConfiguration.day_in_seconds;
        queryParams.end_date =
          endDateFilter + GlobalConfiguration.day_in_seconds;
      }

      const response = await dispatch(remitterAccountViewAll(queryParams));

      const newData = (response?.payload?.remitter_accounts || []).map(
        (account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
        }),
      );

      setAllAccounts(() => [...newData]);
      setMainData(response?.payload);
      setLabels(response?.payload?.summary?.available_labels);
      const rawData = response?.payload?.remitter_accounts || [];
      setAccumulatedData(rawData);
    } catch (error) {
      console.error("Error fetching remitter accounts:", error);
    } finally {
      setAllRemitterAccountLoading(false);
    }
  };

  const filteredData = accumulatedData;

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem(
      "remitterAccountAvailableLabels",
    );
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    dispatch,
    currentPage,
    pageSize,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    searchUserText,
    LabelSearchText,
    currentCategory,
    accountType,
    accountbalancestate,
  ]);

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(currentPage));
    toggleDropdown();
  };

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetDeniedId(id);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setDeclineReason("");
    setShowRejectPopup(false);
    setBtnClicked({});
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
      setisLabelClicked(false);
      setLableId([]);
      setLabelAccounts([]);

      // fetchData();
    }
  };

  const handleRejectLiveStatement = async () => {
    UniversalRefreshToast("Unmatching transactions");

    const remid =
      !remitterAccountViewAllLoading &&
      remitterAccountViewAllData?.remitter_accounts?.[0]
        ?.mapped_itemised_consolidated_statement_entries?.length >
        GlobalConfiguration.lengthCheckZero
        ? remitterAccountViewAllData?.remitter_accounts?.[0]?.mapped_itemised_consolidated_statement_entries?.map(
            (data) => data?.id,
          )
        : [];

    try {
      const response = await dispatch(
        removeUnmatchItemisedStatement({
          remitter_accounts_ids: [deniedId],
          mapping_ids: Array.isArray(remid) ? remid : [remid],
        }),
      );

      if (response?.payload?.status === true) {
        CommonToast({
          text: "Transactions unmatched successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setRejectLiveStatement(false);

        handleDeclined(deniedId, declineReason);
      } else {
        CommonToast({
          text:
            response?.payload?.message ||
            response?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const onClose = () => {
    setShowRejectPopup(false);
  };

  const handleApprovalToastSuccess = () => {
    setApprovedCount((prevCount) => prevCount + 1);

    CommonToast({
      text: "Account approved successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const handleApproval = async (id) => {
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));
    UniversalRefreshToast("approvalaccountsRefresh");

    setBtnClicked((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: "Approve",
    }));

    const data = await dispatch(remitterAccountApprove({ id }));

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "BTDSAccount",
        },
      });
      return;
    }

    let errorMessage = "";
    if (data) {
      const errors = data?.payload?.errors;

      if (errors?.remitter_account?.[0]) {
        SetErrorMessage(errors.remitter_account[0]);
        errorMessage = errors.remitter_account[0];
      } else if (errors?.bank_acc_no?.[0]) {
        SetErrorMessage(errors.bank_acc_no[0]);
        errorMessage = errors.bank_acc_no[0];
      } else if (!data?.payload?.status) {
        SetErrorMessage(errors?.category?.[0]);
        errorMessage = errors?.category?.[0];
      } else {
        SetErrorMessage("An unknown error occurred.");
        errorMessage = "An unknown error occurred.";
      }
    }

    if (data) {
      const updatedData = allAccounts.map((item) => {
        if (item.id === id) {
          let lifecycleStatus = "";

          if (data?.payload?.status === true) {
            lifecycleStatus = "Approved";
          }
          if (data?.payload?.status === false) {
            lifecycleStatus = "error";
          }

          let message = "";
          if (data?.payload?.status === false) {
            const errors = data?.payload?.errors;
            if (errors?.remitter_account?.[0]) {
              message = errors.remitter_account[0];
            } else if (data?.payload?.errors === "false") {
              message = errors?.category?.[0];
            } else if (errors?.bank_acc_no?.[0]) {
              message = errors.bank_acc_no[0];
            }
          }

          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? lifecycleStatus : "pending",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data?.payload?.status === false
                ? message
                : "",
          };
        }

        return item;
      });

      setAllAccounts(updatedData);

      if (data?.payload.status === false) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (data.payload.status === true) {
        toast.dismiss();
        handleApprovalToastSuccess();
        setBtnClicked((prevLoadingStates) => ({
          ...prevLoadingStates,
          [id]: "none",
        }));
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  allAccounts?.forEach((account) => {
    if (account.approval_status === "rejected" && account.error !== "true") {
      deniedCount++;
    }
  });

  const matchedTrasanctionPopup = async (id) => {
    setRemMatchaccountID(id);
    setisDrawerOpen(!isDrawerOpen);
  };

  const moreDetailsPopup = async (id) => {
    setremaccountID(id);
    setisDrawerOpen(!isDrawerOpen);
  };

  const handleDeclined = async (id, AccountIdData) => {
    setShowLoader(true);

    try {
      const data = await dispatch(
        remitterAccountReject({
          id: deniedId,
          rejection_reason: declineReason,
        }),
      );

      // HANDLE REJECTED ACTION
      if (remitterAccountReject.rejected.match(data)) {
        const errorMessage =
          data?.payload?.errors?.remitter_account?.[0] ||
          data?.payload?.errors?.base?.[0] ||
          "Something went wrong";

        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });

        setAllAccounts((prev) =>
          prev.map((acc) =>
            acc.id === deniedId
              ? {
                  ...acc,
                  approval_status: "error",
                  error: "true",
                  message: errorMessage,
                }
              : acc,
          ),
        );
        setShowPopup(false);
        return;
      }

      // HANDLE SUCCESS
      if (data?.payload?.status === true) {
        toast.dismiss();

        if (!(
          matchStatements?.liveStatement || matchStatements?.bankStatement
        )) {
          CommonToast({
            text: "Account rejected successfully.",
            icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }

        setAllAccounts((prev) =>
          prev.map((acc) =>
            acc.id === deniedId
              ? {
                  ...acc,
                  approval_status: "rejected",
                  rejection_reason: declineReason,
                  error: "false",
                }
              : acc,
          ),
        );

        setShowPopup(false);
        setrejectBankStatement(false);
        setRejectLiveStatement(false);
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setDeclineReason("");
      setShowLoader(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !(dateRef.current && dateRef.current.contains(event.target))
      ) {
        setShowDatePicker(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        sidebarButtonRef.current &&
        !sidebarButtonRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClearFilters = () => {
    handleClearSearchParam();
    setAllRemitterAccountLoading(true);
    setShowDatePicker(false);
    setStartDate(null);
    setStartDateFilter("");
    setEndDateFilter("");
    setShowSearchBar(false);
    setCurrentCategory("");
    setPanNumber("") || setAccountNumber("") || setLabelSearchText("");
    setSearchUserTextDebounce("");
    setSearchUserText("");
    handleClearSearchParam();
    setAccountType("");
    setaccountbalancestate("");
    handleClearSearchParam();
  };

  const handleRejectBankStatement = async () => {
    setShowLoader(true);
    UniversalRefreshToast("Unmatching transactions");

    const remitterid =
      !remitterAccountViewAllLoading &&
      remitterAccountViewAllData?.remitter_accounts?.[0]
        ?.mapped_consolidated_statement_entries?.length >
        GlobalConfiguration.lengthCheckZero
        ? remitterAccountViewAllData?.remitter_accounts?.[0]?.mapped_consolidated_statement_entries?.map(
            (data) => data?.id,
          )
        : [];

    try {
      const response = await dispatch(
        removeUnmatchConsolidatedStatement({
          remitter_accounts_ids: [deniedId],
          mapping_ids: Array.isArray(remitterid) ? remitterid : [remitterid],
        }),
      );

      if (response?.payload?.status === true) {
        CommonToast({
          text: "Transactions unmatched successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        setShowLoader(false);

        if (
          remitterAccountDetailsData
            ?.mapped_itemised_consolidated_statement_entries?.length >
          GlobalConfiguration.lengthCheckZero
        ) {
          setRejectLiveStatement(true);
          setrejectBankStatement(false);
          setShowPopup(false);
        } else {
          handleDeclined(deniedId, declineReason);
        }
      } else {
        CommonToast({
          text:
            response?.payload?.message ||
            response?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowPopup(false);
        setShowLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleRejectRemitterAccount = async () => {
    try {
      setShowLoader(true);
      UniversalRefreshToast("accountsRefresh");
      const response = await dispatch(
        remitterAccountViewAll({
          page_no: currentPage,
          page_size: pageSize,
          remitter_account_id: deniedId,
        }),
      );

      if (
        response?.payload?.remitter_accounts?.[0]
          ?.mapped_consolidated_statement_entries?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        setrejectBankStatement(true);
        setShowPopup(false);
      } else if (
        response?.payload?.remitter_accounts?.[0]
          ?.mapped_itemised_consolidated_statement_entries?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        setRejectLiveStatement(true);
        setShowPopup(false);
      } else {
        setShowPopup(false);
        handleDeclined(deniedId, declineReason);
      }
    } catch (error) {
      CommonToast({
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowPopup(false);
    } finally {
      setShowLoader(false);
      setBtnClicked({});
    }
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setAllRemitterAccountLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      remitterAddNewLabel({
        record_ids: toArray(labelId),
        labels: labelsToAssign,
      }),
    );

    if (remitterAddNewLabel.fulfilled.match(res)) {
      await fetchData();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (remitterAddNewLabel.rejected.match(res)) {
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    setAllRemitterAccountLoading(false);
    if (remitterAddNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setAllRemitterAccountLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      remitterRemoveNewLabel({
        record_ids: toArray(labelId),
        labels: labelsToUnassign,
      }),
    );
    await fetchData();
    if (remitterRemoveNewLabel.fulfilled.match(res)) {
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (remitterRemoveNewLabel.rejected.match(res)) {
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    setAllRemitterAccountLoading(false);
    if (remitterRemoveNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const handleCardClick = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopUp(true);
  };

  const handleLeaveConfirm = () => {
    setAlertPopUp(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setAlertPopUp(false);
    setPendingNavTarget(null);
  };

  return (
    <>
      {similarAccountPopup && (
        <>
          <div style={{ zIndex: "var(--z-index-modal)" }}>
            <RemitAccountViewAllPopup
              type={"RemitterAcc"}
              headerTitle={`Similar accounts`}
              propType={`similerAccount`}
              id={similarAccountInfo?.id}
              remName={similarAccountInfo?.name}
              headersubtext={`The following accounts have similar names.`}
              closePopup={() => setSimilarAccountPopup(false)}
              handleConfirmBtnClick={() => {
                return;
              }}
              onCardNavigate
            />
          </div>
        </>
      )}

      {isService && (
        <>
          {" "}
          <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
            {" "}
            <SmallPopupWithBulletPoints
              headerTitle="Matched transactions found"
              secondHeaderFontWeight={true}
              secondHeaderTitle="Feature not assigned for unmatching transactions."
              subtextwithbullet="Y"
              subtext="Contact an authorised person who has the feature to unmatch the following transactions before rejecting this account."
              bulletPoints={[
                ...(matchStatements?.bankStatementCount > 0
                  ? [
                      `Consolidated bank statement: ${matchStatements?.bankStatementCount} transactions`,
                    ]
                  : []),

                ...(matchStatements?.liveStatementCount > 0
                  ? [
                      `Consolidated live statement: ${matchStatements?.liveStatementCount} transactions`,
                    ]
                  : []),
              ]}
              btnOneHandleFunction={() => {
                setIsService(false);
              }}
              btnOneText="Cancel"
              btnTwoHandleFunction={() => {
                return;
              }}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText="Unmatch & reject"
              btnTwoEnabledBgColor="var(--text-disabled)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={true}
              btnTwoIsDisabled={true}
              btnTwoInActiveVariantNeeded={true}
              btnTwoHoverOption="black"
            />
          </div>
        </>
      )}

      {isAlertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle="Open in full view?"
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext="Opening in full view will leave this page and exit the current flow."
            btnOneText="Stay"
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {isLabelPopupOpen && (
        <div
          onClick={() => {
            setIsLabelPopupOpen(false);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex"
          max-zindex
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={() => setIsLabelPopupOpen(false)}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            labelAccounts={labelId}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={(filteredData || []).filter((acc) =>
              Array.isArray(labelId)
                ? labelId.includes(acc?.id)
                : labelId === acc?.id,
            )}
            labelActionDispatchedRef={labelActionDispatchedRef}
            onClose={handleClose}
            loading={allRemitterAccountLoading}
            setLoading={setAllRemitterAccountLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}

      {rejectBankStatement && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <LargePopupRedirect
            headerTitle="Unmatch from consolidated bank statement"
            headersubtext="The following transactions are matched and need to be unmatched before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setrejectBankStatement(false);
              setDeclineReason("");
              setShowLoader(false);
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              hasUnmatchPermission
                ? "To reject the account, please unmatch the transactions listed above by clicking the “Unmatch all” button."
                : "To unmatch the transactions, please contact the authorised person who has the feature to unmatch the transactions."
            }
            isbottomSectionneed={true}
            btnText={"Unmatch all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (hasUnmatchPermission) {
                handleRejectBankStatement();
              } else {
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "RMapping",
                  },
                });
              }
            }}
            isLoaderNeeded={true}
            isLoading={showLoader ? true : false}
            enabledBgColor={
              hasUnmatchPermission
                ? "var(--negative-act)"
                : "var(--text-disabled)"
            }
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <OwnerAccountConsolidatedBankStatement
              popType={"remitterBankStatement"}
              flow={"rejectStatementdetails"}
              remitter_account_id={deniedId}
              setViewstatementOpenPop={() => setrejectBankStatement(false)}
            />
          </LargePopupRedirect>
        </div>
      )}
      {rejectLiveStatement && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <LargePopupRedirect
            headerTitle="Unmatch from consolidated live statement"
            headersubtext="The following transactions are matched and need to be unmatched before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setRejectLiveStatement(false);
              setDeclineReason("");
              setShowLoader(false);
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              hasUnmatchPermission
                ? "To reject the account, please unmatch the transactions listed above by clicking the “Unmatch all” button."
                : "To unmatch the transactions, please contact the authorised person who has the feature to unmatch the transactions."
            }
            isbottomSectionneed={true}
            btnText={"Unmatch all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (hasUnmatchPermission) {
                handleRejectLiveStatement();
              } else {
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "RMapping",
                  },
                });
              }
            }}
            isLoaderNeeded={true}
            isLoading={showLoader ? true : false}
            enabledBgColor={
              hasUnmatchPermission
                ? "var(--negative-act)"
                : "var(--text-disabled)"
            }
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <OwnerAccountItemisedReportComp
              popType={true}
              flow={"rejectStatementdetails"}
              remitter_account_id={deniedId}
              setViewstatementOpenPop={() => setRejectLiveStatement(false)}
            />
          </LargePopupRedirect>
        </div>
      )}

      {/* Popup for entering reason for declining account & transaction */}
      {showPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Reject account"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Provide the reason for rejection."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="Minimum 10 characters required."
            subtextwithbullet="Y"
            bulletPoints={[
              "Once rejected, this account can no longer be used for matching the transactions.",

              ...(matchStatements?.bankStatementCount > 0 ||
              matchStatements?.liveStatementCount > 0
                ? [
                    {
                      text: hasUnmatchPermission
                        ? "Rejecting this account will also unmatch the following transactions:"
                        : "Contact an authorised person who has the feature to unmatch the following transactions before rejecting this account.",
                      subPoints: [
                        ...(matchStatements?.bankStatementCount > 0
                          ? [
                              `Bank transactions: ${matchStatements.bankStatementCount}`,
                            ]
                          : []),

                        ...(matchStatements?.liveStatementCount > 0
                          ? [
                              `Live transactions: ${matchStatements.liveStatementCount}`,
                            ]
                          : []),
                      ],
                    },
                  ]
                : []),
            ]}
            noteColor="text-secondary"
            inputPlaceholder="Reason"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              handleClosePopup();
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText={
              matchStatements?.bankStatement || matchStatements?.liveStatement
                ? "Unmatch & reject"
                : "Reject"
            }
            btnTwoHandleFunction={() => {
              if (
                matchStatements?.bankStatement ||
                matchStatements?.liveStatement
              ) {
                if (hasUnmatchPermission) {
                  unamtchAllTxn(deniedId);
                } else {
                  navigate("/feature_not_assigned", {
                    state: {
                      unavailableService: "RMapping",
                    },
                  });
                }
              } else {
                handleRejectRemitterAccount();
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.trim().length <
              GlobalConfiguration.rejectReasonMinLength
                ? true
                : false
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {isDrawerOpen && (
        <div
          onClick={() => {
            setisDrawerOpen(false);
          }}
        >
          <RemitAccountDetailsPopup
            rem_account_id={
              remaccountID || remMatchaccountID || remUnamtchaccountID
            }
            popup={true}
            headerTitle={"Remitter account details"}
            flow={
              remMatchaccountID
                ? "match_transaction"
                : remUnamtchaccountID
                  ? "unmatch_transaction"
                  : remaccountID
                    ? "more_details"
                    : ""
            }
            closeRemAccountDetailModal={() => {
              setRemMatchaccountID("");
              setRemUnmatchaccountID("");
              setremaccountID("");
              setisDrawerOpen(false);
            }}
          />
        </div>
      )}

      {/* Entire page */}
      <div className="h-screen overflow-hidden flex flex-col">
        <div className=" relative z-z-index-content bg-primary-nav min-h-0 Qmd:min-h-navbar-breadcrumb-height">
          {" "}
        </div>

        <div className=" w-full relative z-z-index-header lg:px-padding-base  flex items-center justify-end m-auto ">
          <TopNavComponent
            direction={direction}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allRemitterAccountLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search remitter account",
              filterPlaceholder: "Name",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    handleSubmit("search", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setSearchUserText(val);
                  },
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: setLabelSearchText,
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: false,
                },
              ],
              filters: [
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    handleSubmit("date", date);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleDateChange(date);
                  },
                },
                {
                  name: "Account state",
                  filterType: "dropdown",
                  variant: "single",
                  isSearch: false,
                  options: ["New", "Edited"],
                  searchPlaceholder: "Select type",
                  dropdownPlaceHolder: "Select type",
                  value: accountType,
                  handleChange: (type) => {
                    handleSubmit("accountType", type);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setAccountType(type);
                  },
                },
              ],
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                accountType !== ""
              ),
              isSearchClearAllDisabled: !(
                currentCategory !== "" ||
                panNumber !== "" ||
                LabelSearchText?.length !==
                  GlobalConfiguration.lengthCheckZero ||
                searchUserText !== "" ||
                accountNumber !== ""
              ),

              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: remiiterLoadingData,
              setLoading: setRemitterLoadingData,
              isShowSortBy: false,
              isShowFilter: true,
              isFilterDisabled: allRemitterAccountLoading,
            }}
          />
        </div>
        <div
          className={`flex-1 flex flex-col overflow-hidden relative ${showInnerSearchBar ? "pointer-events-none" : ""}`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content"></div>
          )}
          <div
            style={{
              paddingBottom:
                remitterAccountApproveData?.summary?.pending_accounts_count ===
                  undefined && "var(--padding-md)",
            }}
            className={`flex flex-col flex-1 items-center overflow-auto overflow-x-hidden w-full pb-padding-lg ${allRemitterAccountLoading ? "h-full" : ""} `}
            onScroll={handleScroll}
          >
            {allRemitterAccountLoading ? (
              <div className="loader-container m-auto justify-center items-center flex">
                <Loader />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className="bene-acc-no-beneaccount-text my-margin-sm">
                  No data found.
                </p>

                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  btnType="button"
                  handleFunction={handleClearFilters}
                  enabledTextColor="var(--text-primary)"
                  fullWidthRequired={false}
                />
              </div>
            ) : allAccounts?.length > GlobalConfiguration.lengthCheckZero ? (
              <div
                className="scroll flex flex-col items-center justify-center w-width-full"
                ref={filterRef}
              >
                <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base  gap-gap-md">
                  {allAccounts?.map((account, index) => {
                    const buildAlerts = () => [
                      ...(account?.similar_name === "Y"
                        ? [
                            {
                              isLoading: false,
                              text: "Similar accounts are found",
                              icon: ICONS?.ALERT,
                              onClick: () => {
                                setSimilarAccountPopup(true);
                                setSimilarAccountInfo({
                                  id: account.id,
                                  name: account.name,
                                });
                              },
                            },
                          ]
                        : []),
                    ];
                    return (
                      <div
                        key={account.id}
                        className={`w-full ${index === 0 ? "mt-margin-md" : ""}`}
                      >
                        <CommonAccountApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={btnClicked?.[account?.id] ?? "none"}
                          entries={[
                            [
                              {
                                type: "textSubtext",
                                text: account.name,
                                subText: "Account name",
                              },
                              {
                                type: "cta",
                                isDisabled:
                                  (account.approval_status === "Approved" &&
                                    account.error === "false" &&
                                    !loading[account.id]) ||
                                  (account.approval_status === "rejected" &&
                                    account.error === "false" &&
                                    !loading[account.id]),
                                text:
                                  account?.mapped_consolidated_statement_entries_count ===
                                  GlobalConfiguration.lengthCheckZero
                                    ? "Not matched"
                                    : `${account?.mapped_consolidated_statement_entries_count} matched`,

                                onClick: () => {
                                  if (
                                    account?.approval_status === "pending" &&
                                    !loading[account?.id]
                                  ) {
                                    setisDrawerOpen(true);
                                    setRemMatchaccountID(account.id);
                                  }
                                },

                                textColor: "var(--pending)",
                                subText: "Consolidated bank statement",
                              },
                              {
                                type: "textSubtext",
                              },
                            ],

                            [
                              {
                                type: "textSubtext",
                                text: account.account_type,
                                subText: "Account state",
                              },
                              {
                                type: "cta",
                                isDisabled:
                                  (account.approval_status === "Approved" &&
                                    account.error === "false" &&
                                    !loading[account.id]) ||
                                  (account.approval_status === "rejected" &&
                                    account.error === "false" &&
                                    !loading[account.id]),
                                text:
                                  account?.mapped_itemised_consolidated_statement_entries_count ===
                                  GlobalConfiguration.lengthCheckZero
                                    ? "Not matched"
                                    : `${account?.mapped_itemised_consolidated_statement_entries_count} matched `,

                                onClick: () => {
                                  if (
                                    account?.approval_status === "pending" &&
                                    !loading[account?.id]
                                  ) {
                                    setisDrawerOpen(true);
                                    setRemUnmatchaccountID(account.id);
                                  }
                                },
                                subText: "Consolidated live statement",
                              },
                            ],
                            [
                              {
                                type: "cta",
                                text:
                                  account?.labels?.join(", ") || "Not assigned",
                                subText: "Labels",
                                onClick: (e) => {
                                  if (
                                    services?.includes("ALabel") &&
                                    services?.includes("RLabel")
                                  ) {
                                    e.stopPropagation();
                                    setLableId(account?.id);
                                    setIsLabelPopupOpen(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "ALabel,RLabel",
                                      },
                                    });
                                  }
                                },
                              },
                              {
                                type: "textSubtext",
                              },
                            ],
                          ]}
                          approveClick={() => handleApproval(account.id)}
                          rejectClick={() => {
                            const updatedMatchStatements = {
                              bankStatement:
                                account?.mapped_consolidated_statement_entries_count >
                                GlobalConfiguration.lengthCheckZero,

                              bankStatementCount:
                                account?.mapped_consolidated_statement_entries_count,

                              liveStatement:
                                account?.mapped_itemised_consolidated_statement_entries_count >
                                GlobalConfiguration.lengthCheckZero,

                              liveStatementCount:
                                account?.mapped_itemised_consolidated_statement_entries_count,
                            };

                            setDeclineReason("");
                            setMatchStatements(updatedMatchStatements);

                            if (
                              (updatedMatchStatements.bankStatementCount >
                                GlobalConfiguration.lengthCheckZero ||
                                updatedMatchStatements.liveStatementCount >
                                  GlobalConfiguration.lengthCheckZero) &&
                              !hasUnmatchPermission
                            ) {
                              setIsService(true);
                            } else {
                              handleOpenPopup(account?.id);

                              setDeclineType("rejectedAccount");

                              setBtnClicked({
                                [account?.id]: "reject",
                                id: account?.id,
                              });
                            }
                          }}
                          ctaBtn1Text={"More details"}
                          ctaBtn1OnClick={
                            account.approval_status === "pending" &&
                            !loading[account.id]
                              ? () => {
                                  moreDetailsPopup(account.id);
                                }
                              : undefined
                          }
                          cardState={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "single"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? account.rejection_reason
                                  ? "double"
                                  : "single"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "single"
                                  : "default"
                          }
                          overlay1Text={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "Approved"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "Rejected"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "Failed to take action!"
                                  : undefined
                          }
                          overlay1Subtext={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "This account has been approved."
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "This account has been rejected."
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? account.message ||
                                    "An error occurred while taking action on this account."
                                  : undefined
                          }
                          overlay1Icon={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? ICONS?.APPROVED_LINEAR
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? ICONS?.REJECTED_RED
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? ICONS?.FAILED_LINEAR
                                  : undefined
                          }
                          overlay1CtaText={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? "View account"
                              : undefined
                          }
                          overlay1CtaOnClick={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? () => {
                                  moreDetailsPopup(account.id);
                                }
                              : undefined
                          }
                          overlay1CtaInactive={false}
                          overlay1CtaDisabled={loading[account.id]}
                          overlay1CtaLoading={loading[account.id]}
                          overlay2Text={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? account.rejection_reason
                              : undefined
                          }
                          overlay2Subtext={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "Rejected reason"
                              : undefined
                          }
                          alerts={buildAlerts()}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : noTransactionsFromAPI ? (
              <div className="flex flex-col gap-gap-sm justify-center items-center m-auto">
                <div className="flex flex-col items-center justify-end">
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt="No accounts found"
                    className={"w-graphic-width-md h-graphic-square-height-md"}
                  />
                </div>

                <div className="flex flex-col gap-gap-sm items-center">
                  <p className="text-text-primary text-font-sm font-normal">
                    There are no pending accounts for your approval.
                  </p>

                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Tax account dashboard"
                    btnType="button"
                    handleFunction={() => navigate("/tax_account_dashboard")}
                    enabledTextColor="var(--text-primary)"
                  />
                </div>
              </div>
            ) : null}
          </div>
          <div className="h-pagination-height flex-shrink-0"></div>
          {!allRemitterAccountLoading && accumulatedData?.length > 0 && (
            <div className="w-width-full bottom-bottom-base fixed z-z-index-content">
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}

              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={currentPage}
                setIsOpen={setIsOpen}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RemitterAccountApproval;
